import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';

export default class ReserveActionFilter extends Component {
    static propTypes = {
        filter: PropTypes.any,
        onChange: PropTypes.func
    };

    render() {
        return (
            <input
                className="filter-input reserve-action-filter"
                onChange={(event) => this.props.onChange(event.target.value)}
                value={get(this.props, 'filter.value', '')}
                type="string"
            />
        );
    }
}
